import React from "react";
import { Stack } from "react-bootstrap";
import { cn } from "../../utils/helpers";
import { Flex } from "antd";

export const Card = ({ children, header, ...restProps }) => {
  const { className, ...rest } = restProps;

  return (
    <div
      className={cn("card border border-1 rounded-3 m-0", className)}
      {...rest}
    >
      <div className="card-body w-100">
        {/* Header */}
        {header && (
          <Flex
            style={{ width: "100%" }}
            align="center"
            justify="space-between"
            gap={2}
            wrap
            className="border-bottom pb-4 mb-4"
          >
            {header}
          </Flex>
        )}

        {/* body */}
        {children}
      </div>
    </div>
  );
};
